const styles = theme => ({
  noDataContainer: {
    display: 'inline-flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '8px',
  },
  noDataIcon: {
    width: '100px',
    height: '100px',
    [theme.breakpoints.down('xs')]: {
      width: '60px',
      height: '60px',
    },
  },
  headline: {
    fontSize: '16px',
    fontWeight: 600,
    color: theme.palette.primary.adgmBlack,
    lineHeight: '18px',
    textAlign: 'center',
    [theme.breakpoints.down('xs')]: {
      fontSize: '14px',
      lineHeight: '21px',
    },
  },
  text: {
    fontSize: '14px',
    lineHeight: '21px',
    color: theme.palette.primary.darkGrey,
    textAlign: 'center',
    [theme.breakpoints.down('xs')]: {
      fontSize: '12px',
      lineHeight: '18px',
    },
  },
});

export default styles;
